function initMediaButtonHandlers() {
  document.querySelectorAll('.open-media-pswp').forEach((button) => {
    const ariaLabel = button.getAttribute('aria-label');
    const images = document.querySelectorAll('media-gallery img');
    images.forEach((img) => {
      const src = img.getAttribute('src') || img.getAttribute('data-src');
      if (src && src.includes(`-${ariaLabel}`)) {
        const parentWithMediaId = img.closest('[data-media-id]');
        const nextEl = img.nextElementSibling;
        const mediaId = parentWithMediaId.getAttribute('data-media-id');
        if (parentWithMediaId) {
          const targetEl = document.getElementById('mediaAttr');
          if (targetEl) targetEl.click();

          button.setAttribute('data-id', 'data-id' + mediaId);
          if (nextEl) nextEl.id = 'data-id' + mediaId;

          button.addEventListener('click', () => {
            const triggerTarget = document.getElementById('data-id' + mediaId);
            if (triggerTarget) triggerTarget.click();
          });
        }
      }
    });
  });
}

// Initial run
document.addEventListener('DOMContentLoaded', initMediaButtonHandlers);

// Shopify customizer section reload (live editor)
document.addEventListener('shopify:section:load', initMediaButtonHandlers);
document.addEventListener('shopify:section:select', initMediaButtonHandlers);

function scrollToReview() {
  const target = document.querySelector("reviewsio-product-reviews-widget");
  const headerOffset = document.querySelector('header')?.offsetHeight || 80; // adjust default offset as needed

  if (target) {
    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

// Attach listener to all clickable review links
document.querySelectorAll('.scroll-to-review').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    scrollToReview();
  });
});

// Globo Search: getippten Teil der Suggestions per <mark> auszeichnen (wie die native Predictive Search).
(function () {
  const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  function getQuery() {
    const active = document.activeElement;
    const input = active && active.matches && active.matches('input.gf-autocomplete-input')
      ? active
      : [...document.querySelectorAll('input.gf-autocomplete-input')].find((el) => el.value.trim());
    return input ? input.value.trim() : '';
  }

  function highlightSuggestions(popup) {
    const query = getQuery();
    if (!query) return;
    const terms = query.split(/\s+/).filter(Boolean).map(escapeRegExp);
    const regex = new RegExp(`(${terms.join('|')})`, 'gi');

    popup.querySelectorAll('.gf-search-suggestions a.ui-menu-item-wrapper').forEach((link) => {
      if (link.querySelector('mark') || link.children.length) return;
      const text = link.textContent;
      if (!regex.test(text)) return;
      regex.lastIndex = 0;
      link.textContent = '';
      text.split(regex).forEach((part, index) => {
        if (index % 2 === 1) {
          const mark = document.createElement('mark');
          mark.textContent = part;
          link.appendChild(mark);
        } else if (part) {
          link.appendChild(document.createTextNode(part));
        }
      });
    });
  }

  // Das Dropdown zeigt (anders als das mobile Vollbild-Layout) nur den aktuellen Preis. Den durchgestrichenen
  // alten Preis laden wir aus dem Produkt-JSON nach, damit Rabatte wie in der bisherigen Suche sichtbar sind.
  const compareCache = new Map();

  function fetchComparePrice(handle) {
    if (!compareCache.has(handle)) {
      compareCache.set(
        handle,
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => (product && product.compare_at_price > product.price ? product.compare_at_price : 0))
          .catch(() => 0)
      );
    }
    return compareCache.get(handle);
  }

  // Formatiert Cent-Beträge im selben Stil (Währungszeichen, Dezimaltrenner) wie der von Globo angezeigte Preis.
  function formatLike(priceText, cents) {
    const match = priceText.match(/\d[\d.,]*/);
    if (!match) return '';
    const decimalComma = /,\d{1,2}$/.test(match[0]);
    const amount = (cents / 100).toFixed(2).replace('.', decimalComma ? ',' : '.');
    return priceText.replace(match[0], amount).trim();
  }

  function showComparePrices(popup) {
    popup.querySelectorAll('.gf-search-item-product.gf-product-card').forEach((item) => {
      const priceBox = item.querySelector('.gf-search-item-product-price');
      const link = item.querySelector('a.product-card__link');
      if (!priceBox || !link || priceBox.dataset.comparePrice) return;
      priceBox.dataset.comparePrice = 'pending';

      const handle = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!handle) return;

      fetchComparePrice(handle[1]).then((compare) => {
        priceBox.dataset.comparePrice = 'done';
        if (!compare) return;
        const text = formatLike(priceBox.textContent, compare);
        if (!text) return;
        const old = document.createElement('span');
        old.className = 'gf-search-item-compare-price';
        old.textContent = text;
        priceBox.appendChild(old);
        priceBox.classList.add('gf-search-item-product-price--sale');
      });
    });
  }

  // "Did you mean Immu Pro (11)?" -> Trefferzahl in Klammern entfernen.
  function hideSpellingCorrectionCount(popup) {
    popup.querySelectorAll('.gf-search-spelling-correction, .gl-spelling-correction').forEach((el) => {
      el.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && /\(\d+\)/.test(node.textContent)) {
          node.textContent = node.textContent.replace(/\s*\(\d+\)/, '');
        }
      });
    });
  }

  // Globo setzt Position/Breite per Inline-Style und trifft das Suchfeld im Drawer am Desktop nicht (Popup ragt
  // links über das Panel hinaus bzw. rechts darüber hinaus). Daher bündig mit dem Suchfeld ausrichten (mobil: CSS).
  function alignToInput(popup) {
    if (popup.style.display === 'none' || window.matchMedia('(max-width: 767px)').matches) return;
    const input = document.querySelector('#SearchDrawer input.gf-autocomplete-input');
    if (!input) return;

    const rect = input.getBoundingClientRect();
    if (!rect.width) return;
    const left = `${Math.round(rect.left + window.scrollX)}px`;
    const width = `${Math.round(rect.width)}px`;
    if (popup.style.left === left && popup.style.width === width) return;
    popup.style.setProperty('left', left, 'important');
    popup.style.setProperty('width', width, 'important');
  }

  function observePopup(popup) {
    if (popup.dataset.suggestionHighlight) return;
    popup.dataset.suggestionHighlight = 'true';
    const align = () => alignToInput(popup);
    new MutationObserver(align).observe(popup, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', align);
    document.getElementById('SearchDrawer')?.addEventListener('transitionend', align);
    const update = () => {
      align();
      highlightSuggestions(popup);
      hideSpellingCorrectionCount(popup);
      showComparePrices(popup);
    };
    new MutationObserver(update).observe(popup, { childList: true, subtree: true });
    update();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const observeAll = () => document.querySelectorAll('.glFilter-search-popup').forEach(observePopup);
    observeAll();
    new MutationObserver(observeAll).observe(document.body, { childList: true });
  });
})();

// Weiterleitung von /search: Such-Drawer auf der Startseite automatisch öffnen.
(function () {
  const params = new URLSearchParams(location.search);
  if (!params.has('open_search')) return;

  params.delete('open_search');
  const query = params.toString();
  history.replaceState(null, '', location.pathname + (query ? `?${query}` : '') + location.hash);

  window.addEventListener('load', () => {
    customElements.whenDefined('search-drawer').then(() => {
      document.querySelector('[aria-controls="SearchDrawer"]')?.click();
    });
  });
})();

// Es gibt keine Suchergebnisseite: Enter im Suchfeld soll nichts auslösen (Auswahl per Pfeiltasten + Enter bleibt möglich).
// Gilt für Globo und – falls Globo abgeschaltet ist (z. B. A/B-Test) – auch für die native Predictive Search im Drawer.
const SEARCH_INPUT_SELECTOR = 'input.gf-autocomplete-input, input.gl-d-searchbox-input, #SearchDrawer input.search__input';

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || !event.target.matches(SEARCH_INPUT_SELECTOR)) return;
  const popup = document.querySelector('ul.glFilter-search-popup [aria-selected="true"]');
  if (!popup) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

document.addEventListener('submit', (event) => {
  if (event.target.querySelector && event.target.querySelector(SEARCH_INPUT_SELECTOR)) event.preventDefault();
}, true);

// Es gibt keine Suchergebnisseite: Links auf /search?q=… (Suggestions, "Did you mean", Popular searches)
// setzen den Begriff stattdessen ins Suchfeld und starten die Suche direkt im Drawer.
document.addEventListener('click', (event) => {
  const link = event.target.closest && event.target.closest('.glFilter-search-popup a[href*="/search?"], #SearchDrawer .search__results a[href*="/search?"]');
  if (!link) return;

  const url = new URL(link.href, location.origin);
  const term = url.searchParams.get('q');
  if (!term || !/\/search\/?$/.test(url.pathname)) return;

  const fullscreen = link.closest('.gl-filter-search-fullscreen');
  const input = fullscreen
    ? fullscreen.querySelector('input.gl-d-searchbox-input')
    : document.querySelector('#SearchDrawer input.search__input');
  if (!input) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  input.focus();
  input.value = term;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new KeyboardEvent('keydown', { key: term.slice(-1), bubbles: true }));
  input.dispatchEvent(new KeyboardEvent('keyup', { key: term.slice(-1), bubbles: true }));
}, true);
